import axiosInstance from './axiosInstance'

// 数据查询API响应处理函数
const handleResponse = (response) => {
  const data = response.data
  if (data.code === 200) {
    return data
  } else {
    throw new Error(data.message || '请求失败')
  }
}

// 获取数据汇总信息
export function getDataSummary() {
  return axiosInstance.get('/api/flyer_student/data_query/summary').then(handleResponse)
}

// CFC相关API
export function getCfcData(params) {
  return axiosInstance.get('/api/flyer_student/data_query/cfc', { params }).then(handleResponse)
}

export function getCfcProjects() {
  return axiosInstance.get('/api/flyer_student/data_query/cfc/projects').then(handleResponse)
}

// 周测相关API
export function getWeeklyTestData(params) {
  return axiosInstance.get('/api/flyer_student/data_query/weekly_test', { params }).then(handleResponse)
}

export function getWeeklyTests() {
  return axiosInstance.get('/api/flyer_student/data_query/weekly_test/tests').then(handleResponse)
}

// 心理测评相关API
export function getPsychologicalTestData(params) {
  return axiosInstance.get('/api/flyer_student/data_query/psychological_test', { params }).then(handleResponse)
}

export function getPsychologicalTests() {
  return axiosInstance.get('/api/flyer_student/data_query/psychological_test/tests').then(handleResponse)
}

// 体测相关API
export function getPhysicalTestData(params) {
  return axiosInstance.get('/api/flyer_student/data_query/physical_test', { params }).then(handleResponse)
}

export function getPhysicalTests() {
  return axiosInstance.get('/api/flyer_student/data_query/physical_test/tests').then(handleResponse)
}
